const CATEGORY_COLORS = [
  "#F97316",
  "#F59E0B",
  "#FACC15",
  "#84CC16",
  "#22C55E",
  "#14B8A6",
  "#06B6D4",
  "#3B82F6",
  "#6366F1",
  "#A855F7",
  "#EC4899",
  "#F43F5E",
];

const DEFAULT_CATEGORY_ICON = "🍽️";

const normalizeValue = (value) => String(value ?? "").trim();

const hashString = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const pickFallbackColor = (category) => {
  const seed = [
    normalizeValue(category?.id),
    normalizeValue(category?.name),
    normalizeValue(category?.slug),
  ]
    .filter(Boolean)
    .join("|");
  const safeSeed = seed || "moo";
  const index = hashString(safeSeed) % CATEGORY_COLORS.length;
  return CATEGORY_COLORS[index];
};

export const applyCategoryDefaults = (category) => {
  if (!category || typeof category !== "object") return category;
  const color = normalizeValue(category.color);
  const icon = normalizeValue(category.icon);
  return {
    ...category,
    color: color || pickFallbackColor(category),
    icon: icon || DEFAULT_CATEGORY_ICON,
  };
};

export const DEFAULT_CATEGORY_EMOJI = DEFAULT_CATEGORY_ICON;
